webpackJsonp([0,18],{

/***/ "G8nc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.legit && _vm.show)?_c('article',{staticClass:"project type-project status-publish hentry"},[(_vm.page)?_c('header',{staticClass:"entry-header bg-parent",style:({ backgroundColor: _vm.page.header_background, color: _vm.page.header_colour})},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.page.header_image[0]),expression:"'https://api.alt-design.net/api/image/' + page.header_image[0]",arg:"background-image"}],staticClass:"bg-fade"}),_vm._v(" "),_c('p',{staticClass:"sectors"},[_vm._v(_vm._s(_vm.page.sub_title))]),_vm._v(" "),_c('h1',{staticClass:"entry-title"},[_vm._v(_vm._s(_vm.page.title))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"entry-content"},[(_vm.content)?_c('page-builder',{attrs:{"content":_vm.content}}):_vm._e(),_vm._v(" "),(_vm.pagination)?_c('nav',{staticClass:"animateIn navigation",attrs:{"role":"navigation"}},[_c('div',{staticClass:"nav-next"},[_c('router-link',{attrs:{"to":'/work/' + _vm.pagination.previous.slug,"title":"View Previous Project"}},[_c('h2',{staticClass:"name"},[_vm._v(_vm._s(_vm.pagination.previous.title))]),_vm._v(" "),_c('p',{staticClass:"tag"},[_vm._v(_vm._s(_vm.pagination.previous.sub_title))]),_vm._v(" "),_c('p',{staticClass:"button"},[_vm._v("Previous")])])],1),_vm._v(" "),_c('div',{staticClass:"nav-previous"},[_c('router-link',{attrs:{"to":'/work/' + _vm.pagination.next.slug,"title":"View next Project"}},[_c('h2',{staticClass:"name"},[_vm._v(_vm._s(_vm.pagination.next.title))]),_vm._v(" "),_c('p',{staticClass:"tag"},[_vm._v(_vm._s(_vm.pagination.next.sub_title))]),_vm._v(" "),_c('p',{staticClass:"button"},[_vm._v("Next")])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"social-buttons animateIn"},[_c('ul',[_c('h2',{staticClass:"title"},[_vm._v("Follow us!")]),_vm._v(" "),_c('li',{staticClass:"facebook"},[_c('a',{attrs:{"href":"https://www.facebook.com/altdesignderby/","target":"_blank","title":"Find us on Facebook"}},[_c('span',{staticClass:"icon-facebook"})])]),_vm._v(" "),_c('li',{staticClass:"twitter"},[_c('a',{attrs:{"href":"https://twitter.com/_altdesign","target":"_blank","title":"Follow us on Twitter"}},[_c('span',{staticClass:"icon-twitter"})])]),_vm._v(" "),_c('li',{staticClass:"instagram"},[_c('a',{attrs:{"href":"https://www.instagram.com/_altdesign/","target":"_blank","title":"Follow us on Instagram"}},[_c('span',{staticClass:"icon-instagram"})])])])])],1)]):(_vm.legit)?_c('loading'):_c('missing')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J+Cz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"page type-page status-publish hentry"},[_c('div',{staticClass:"entry-content"},[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('h2',{staticClass:"alt-title"},[_vm._v("404 - Sorry! We don't have this thing here.")]),_vm._v(" "),_c('div',{staticClass:"cols"},[_c('div',{staticClass:"col left"},[_c('p',{staticClass:"intro"},[_vm._v("Maybe we have it elsewhere? Try "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("our homepage")]),_vm._v(" - it's probably there. Potentially, it's been moved, or just simply doesn't exist. If you still cannot find it, or would like to discuss a replacement thing, "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("contact us")]),_vm._v(", and we'll check behind the back of the sofa. Just in case.")],1)])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"entry-header missing"},[_c('h1',{staticClass:"entry-title"},[_vm._v("Erm... What are you looking for?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-buttons animateIn"},[_c('ul',[_c('h2',{staticClass:"title"},[_vm._v("Follow us!")]),_vm._v(" "),_c('li',{staticClass:"facebook"},[_c('a',{attrs:{"href":"https://www.facebook.com/altdesignderby/","target":"_blank","title":"Find us on Facebook"}},[_c('span',{staticClass:"icon-facebook"})])]),_vm._v(" "),_c('li',{staticClass:"twitter"},[_c('a',{attrs:{"href":"https://twitter.com/_altdesign","target":"_blank","title":"Follow us on Twitter"}},[_c('span',{staticClass:"icon-twitter"})])]),_vm._v(" "),_c('li',{staticClass:"instagram"},[_c('a',{attrs:{"href":"https://www.instagram.com/_altdesign/","target":"_blank","title":"Follow us on Instagram"}},[_c('span',{staticClass:"icon-instagram"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JPjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("gnCF");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d39c9258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("G8nc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d39c9258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bQA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$setSeo('Graphic Design Agency / Brand Consultants Midlands | Alt Design', 'Based in Derby, Alt Design are one of the top graphic design agencies in the Midlands specialising in branding, print, and web design. Call us on 01332 208733.');
  }
});

/***/ }),

/***/ "fnPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__("bQA7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cac1c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("J+Cz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cac1c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gnCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__404_vue__ = __webpack_require__("fnPC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      legit: true,
      page: '',
      content: '',
      pagination: '',
      show: false,
      sectors: []
    };
  },
  created: function created() {
    var _this = this;

    window.api.get('get-pages/' + this.$route.params.project).then(function (res) {
      if (res.data.res === false) {
        _this.legit = false;
        return;
      }
      _this.page = res.data.data.page;
      if (_this.page.header_image[0]) {
        document.querySelector('meta[property="og:image"]').content = 'https://api.alt-design.net/api/image/' + _this.page.header_image[0];
      }

      // Check and set SEO
      if (_this.page.seo_title && _this.page.seo_title.length > 0 && _this.page.seo_description.length > 0) {
        _this.$setSeo(_this.page.seo_title, _this.page.seo_description);
      } else {
        _this.$setSeo(_this.page.title + ' - Alt Design - Graphic Design and Web Development in Derby', 'Based in Derby, Alt Design are one of the top graphic design agencies in the Midlands specialising in branding, print, and web design. Call us on 01332 208733.');
      }
      _this.content = res.data.data.content;
      _this.pagination = res.data.data.pagination;
      _this.$store.commit('setCurrentSectors', _this.page.sectors);
    }).then(function () {
      _this.show = true;
      _this.$nextTick(function () {
        _this.$setTweens();
      });
    });
  },

  components: {
    missing: __WEBPACK_IMPORTED_MODULE_0__404_vue__["default"]
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.076c8bccc6f8e70a2ae8.js